import { apiPost } from '../shared/apiClient';

// Short Maps links (maps.app.goo.gl) can't be followed from the browser, so the
// server follows the redirect and returns the full link; parsing stays here.
export function resolveMapsLink(url) {
  return apiPost('/maps/resolve-link', { url }).then(res => res.data?.data?.resolved_url || null);
}

export function resolveErrorCopy(error) {
  if (error?.response?.status === 429) return 'Too many link lookups. Wait a minute and try again.';
  return "Couldn't read this link. Open it and copy the coordinates.";
}
